import { Component, OnInit, Input, Inject, EventEmitter, Output, OnChanges } from '@angular/core';
import { DisplayMode } from '../toolbar-popover/toolbar-popover.component';
import { RcDeviceService } from '../../services/rc-device-service';
import { XsI18nPipe } from '@nx-fe/pipes';
import { DEVICE_OS_FAMILY, FeatureToggleService, hd } from '@nx-fe/services';
import {
  WorkPanelBarItem,
  WorkPanelBarItemType,
} from 'app/modules/ticket/components/work-panel/models/work-panel-bar-items';
import { RcContext } from 'app/modules/remote-control-ng/context/rcContext';
import { RemoteControlDeviceState } from '../../services/device-state-registry.service';

type IDeviceModel = hd.IDeviceModel;

interface IButtonInfo {
  name: string;
  value: number;
  toolTipName: string;
}

@Component({
  selector: 'app-device-buttons',
  templateUrl: './device-buttons.component.html',
  styleUrls: ['./device-buttons.component.scss'],
})
export class DeviceButtonsComponent implements OnInit, OnChanges {
  @Input() rcState: RemoteControlDeviceState;

  @Output() showDeviceButtons = new EventEmitter<boolean>();

  private mobileDeviceIcon = 'hd-icon-device1';
  private windowsDesktopIcon = 'hd-icon-windowsdesktop';
  private hdIconHome = 'hd-icon-home';
  private hdIconBack = 'hd-icon-back';
  private hdIconVolhigh = 'hd-icon-volhigh';
  private hdIconVollow = 'hd-icon-vollow';
  private hdIconLock = 'hd-icon-lock';
  private hdIconMenu = 'hd-icon-menu';
  private hdIconWinmodern = 'hd-icon-winmodern';
  private hdIconSearch = 'hd-icon-search';

  public displayMode = DisplayMode;
  public collapsedButtonItem: WorkPanelBarItem = <WorkPanelBarItem>{
    name: 'collapsedButtonIcon',
    type: WorkPanelBarItemType.Button,
    tooltip: () => this.saI18nPipe.transform('remoteControl_btn_DeviceControls'),
    onClick: () => {},
    icon: () => this.getCollapsedButtonIcon(),
    cssClass: () => 'toolbar-popover-single-item',
    isVisible: () => true,
    isDisabled: () => false,
  };

  public expandedButtonItems: WorkPanelBarItem[];

  private androidPlusExpandedButtonItems: WorkPanelBarItem[] = [
    <WorkPanelBarItem>{
      name: 'androidPlus',
      type: WorkPanelBarItemType.Button,
      tooltip: () => this.saI18nPipe.transform('remoteControl_btn_DeviceControls'),
      onClick: () => {},
      icon: () => this.getCollapsedButtonIcon(),
      isVisible: () => true,
      isDisabled: () => false,
    },
    <WorkPanelBarItem>{
      name: this.hdIconHome,
      type: WorkPanelBarItemType.Button,
      tooltip: () => this.saI18nPipe.transform('remoteControl_btn_Home'),
      onClick: () => {
        this.pressDeviceButton(this.hdIconHome, 3);
      },
      icon: () => this.hdIconHome,
      isVisible: () => true,
      isDisabled: () => false,
    },
    <WorkPanelBarItem>{
      name: this.hdIconBack,
      type: WorkPanelBarItemType.Button,
      tooltip: () => this.saI18nPipe.transform('remoteControl_btn_GoBack'),
      onClick: () => {
        this.pressDeviceButton(this.hdIconBack, 4);
      },
      icon: () => this.hdIconBack,
      isVisible: () => true,
      isDisabled: () => false,
    },
    <WorkPanelBarItem>{
      name: this.hdIconVolhigh,
      type: WorkPanelBarItemType.Button,
      tooltip: () => this.saI18nPipe.transform('remoteControl_btn_VolumeUp'),
      onClick: () => {
        this.pressDeviceButton(this.hdIconVolhigh, 24);
      },
      icon: () => this.hdIconVolhigh,
      isVisible: () => true,
      isDisabled: () => false,
    },
    <WorkPanelBarItem>{
      name: this.hdIconVollow,
      type: WorkPanelBarItemType.Button,
      tooltip: () => this.saI18nPipe.transform('remoteControl_btn_VolumeDown'),
      onClick: () => {
        this.pressDeviceButton(this.hdIconVollow, 25);
      },
      icon: () => this.hdIconVollow,
      isVisible: () => true,
      isDisabled: () => false,
    },
    <WorkPanelBarItem>{
      name: this.hdIconLock,
      type: WorkPanelBarItemType.Button,
      tooltip: () => this.saI18nPipe.transform('remoteControl_btn_Lock'),
      onClick: () => {
        this.pressDeviceButton(this.hdIconLock, 26);
      },
      icon: () => this.hdIconLock,
      isVisible: () => true,
      isDisabled: () => false,
    },
    <WorkPanelBarItem>{
      name: this.hdIconMenu,
      type: WorkPanelBarItemType.Button,
      tooltip: () => this.saI18nPipe.transform('remoteControl_btn_Menu'),
      onClick: () => {
        this.pressDeviceButton(this.hdIconMenu, 82);
      },
      icon: () => this.hdIconMenu,
      isVisible: () => true,
      isDisabled: () => false,
    },
  ];

  private windowsPhoneExpandedButtonItems: WorkPanelBarItem[] = [
    <WorkPanelBarItem>{
      name: 'windowsPhone',
      type: WorkPanelBarItemType.Button,
      tooltip: () => this.saI18nPipe.transform('remoteControl_btn_DeviceControls'),
      onClick: () => {},
      icon: () => this.getCollapsedButtonIcon(),
      isVisible: () => true,
      isDisabled: () => false,
    },
    <WorkPanelBarItem>{
      name: this.hdIconBack,
      type: WorkPanelBarItemType.Button,
      tooltip: () => this.saI18nPipe.transform('remoteControl_btn_GoBack'),
      onClick: () => {
        this.pressDeviceButton(this.hdIconBack, 0);
      },
      icon: () => this.hdIconBack,
      isVisible: () => true,
      isDisabled: () => false,
    },
    <WorkPanelBarItem>{
      name: this.hdIconWinmodern,
      type: WorkPanelBarItemType.Button,
      tooltip: () => this.saI18nPipe.transform('remoteControl_btn_Windows'),
      onClick: () => {
        this.pressDeviceButton(this.hdIconWinmodern, 1);
      },
      icon: () => this.hdIconWinmodern,
      isVisible: () => true,
      isDisabled: () => false,
    },
    <WorkPanelBarItem>{
      name: this.hdIconSearch,
      type: WorkPanelBarItemType.Button,
      tooltip: () => this.saI18nPipe.transform('remoteControl_btn_Search'),
      onClick: () => {
        this.pressDeviceButton(this.hdIconSearch, 2);
      },
      icon: () => this.hdIconSearch,
      isVisible: () => true,
      isDisabled: () => false,
    },
    <WorkPanelBarItem>{
      name: this.hdIconVolhigh,
      type: WorkPanelBarItemType.Button,
      tooltip: () => this.saI18nPipe.transform('remoteControl_btn_VolumeUp'),
      onClick: () => {
        this.pressDeviceButton(this.hdIconVolhigh, 175);
      },
      icon: () => this.hdIconVolhigh,
      isVisible: () => true,
      isDisabled: () => false,
    },
    <WorkPanelBarItem>{
      name: this.hdIconVollow,
      type: WorkPanelBarItemType.Button,
      tooltip: () => this.saI18nPipe.transform('remoteControl_btn_VolumeDown'),
      onClick: () => {
        this.pressDeviceButton(this.hdIconVollow, 174);
      },
      icon: () => this.hdIconVollow,
      isVisible: () => true,
      isDisabled: () => false,
    },
  ];

  private windowsDesktopExpandedButtonItems: WorkPanelBarItem[] = [
    <WorkPanelBarItem>{
      name: 'windowsDesktopExpanded',
      type: WorkPanelBarItemType.Button,
      tooltip: () => this.saI18nPipe.transform('remoteControl_btn_DeviceControls'),
      onClick: () => {},
      icon: () => this.getCollapsedButtonIcon(),
      isVisible: () => true,
      isDisabled: () => false,
    },
    <WorkPanelBarItem>{
      name: this.hdIconLock,
      type: WorkPanelBarItemType.Button,
      tooltip: () => this.saI18nPipe.transform('remoteControl_btn_Lock'),
      onClick: () => {
        this.pressDeviceButton(this.hdIconLock, 46);
      },
      icon: () => this.hdIconLock,
      isVisible: () => true,
      isDisabled: () => false,
    },
  ];

  constructor(
    private featureToggleService: FeatureToggleService,
    private saI18nPipe: XsI18nPipe,
    private deviceService: RcDeviceService,
  ) {}

  ngOnInit() {}

  ngOnChanges() {
    if (this.rcState) {
      this.buildRcMenuButtonItems();
      this.expandedButtonItems.length > 0 ? this.showDeviceButtons.emit(true) : this.showDeviceButtons.emit(false);
    }
  }

  public pressDeviceButton = (keyname: string, key: number) => {
    const deviceInput = RcContext.instance.deviceInput;
    if (deviceInput !== undefined) {
      if (keyname === this.hdIconLock && key === 46) {
        deviceInput.sendKeyboardKey(key, false, true, true, false);
      } else {
        deviceInput.sendSkinKey(key);
      }
    }
  };

  private getCollapsedButtonIcon = () => {
    if (this.rcState && this.rcState.device) {
      const deviceFamily = this.deviceService.getDeviceFamily(this.rcState.device.kind, this.rcState.device.family);
      switch (deviceFamily) {
        case DEVICE_OS_FAMILY.Android:
        case DEVICE_OS_FAMILY.AndroidPlus:
        case DEVICE_OS_FAMILY.WindowsPhone:
          return this.mobileDeviceIcon;
        case DEVICE_OS_FAMILY.WindowsRuntime:
        case DEVICE_OS_FAMILY.WindowsDesktop:
          return this.windowsDesktopIcon;
      }
    }

    return '';
  };

  private buildRcMenuButtonItems = () => {
    this.expandedButtonItems = [];

    if (this.rcState && this.rcState.device) {
      const deviceFamily = this.deviceService.getDeviceFamily(this.rcState.device.kind, this.rcState.device.family);
      switch (deviceFamily) {
        case DEVICE_OS_FAMILY.Android:
        case DEVICE_OS_FAMILY.AndroidPlus:
          this.expandedButtonItems = this.androidPlusExpandedButtonItems;
          break;

        case DEVICE_OS_FAMILY.WindowsPhone:
          this.expandedButtonItems = this.windowsPhoneExpandedButtonItems;
          break;

        case DEVICE_OS_FAMILY.WindowsRuntime:
        case DEVICE_OS_FAMILY.WindowsDesktop:
          this.expandedButtonItems = this.windowsDesktopExpandedButtonItems;
          break;
      }
    }
  };
}
